import { setData } from '@/actions/auth';
import {
  addCourseEnroll,
  addCourseToWishList,
  getCourseDetail,
  getCourseReview,
  getCourseVedio
} from '@/actions/courses';

import { modifyHelperReducerData } from '@/actions/helperAction';
import { getMockTestList } from '@/actions/mock-test';
import { setPaymentEditData } from '@/actions/payment';
import { InnerHtmlReadMore } from '@/components/common/read-more';
import CustomCourseCarousel from '@/components/CustomCourseCarousel';
import { isLogin } from '@/helpers/loginHelper';
import { timeConvert, timeToMinutes } from '@/helpers/timeHelper';
import useWidth, { IBooleanArgs } from '@/helpers/widthUtil';
import { HeartFilled, HeartOutlined, ShoppingCartOutlined } from "@ant-design/icons";
import { Badge, Button, Collapse, Empty, List, Modal, Rate, Skeleton } from 'antd';
import classnames from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import React, { FC, useEffect, useRef, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import Login from '../home/Login';
import TutorListView from '../tutor/all-tutors/TutorList';
import CourseReview from './review/course-review';
import Video from './Video';
import VideoHLS from './video/index';
import videojs from 'video.js';
interface IPreviewContents {
  video: string;
  name: string;
}

type CourseDetailsProps = { course: object | any };
const CourseDetails: FC<CourseDetailsProps> = ({ course }) => {
  const [activeTab, setActiveTab] = React.useState<string>('1');
  const { isMobile, isLaptop, isTablet }: IBooleanArgs = useWidth();
  const mockTestLanding = useSelector(
    (state: RootStateOrAny) => state?.MockTestReducer?.mockTestLanding
  );
  const [mockTestQuery, setMockTestQuery] = useState<object>({
    page: 1,
    per_page: 5,
    course: course?.slug,
  });

  const { Panel } = Collapse;
  const dispatch = useDispatch();
  const ref = React.useRef<HTMLSpanElement>();
  const [modalLessonOpen, setModalVideoOpen] = useState<boolean>(false);
  const [video, setVideo] = useState<string>('');
  const [videoSlug, setVideoSlug] = useState<string>('');
  const [videoIndex, setVideoIndex] = useState<number>(0);
  const [isReadMore, setIsReadMore] = useState<boolean>(true);
  const [clickPreview, setClickPreview] = useState<object>({
    clicked: false,
    videoSlug: {},
  });

  const [auth, setAuth] = useState<boolean>(false);
  const [previewContents, setPreviewContents] = useState<Array<IPreviewContents>>(
    []
  );
  const [videoPreviewMode, setVideoPreviewMode] = useState<boolean>(false);

  const modalRef: any = useRef<HTMLDivElement>();

  const courseVideo = useSelector((state: RootStateOrAny) => state.courses.video);
  const { loginModal, registerModal } = useSelector(
    (state: RootStateOrAny) => state.auth.helperObj
  );
  const courseEnroll = useSelector(
    (state: RootStateOrAny) => state.courses?.courseDetail?.data
  );
  const loading = useSelector(
    (state: RootStateOrAny) => state?.courses?.courseDetail?.loading
  );
  const courseReviews = useSelector(
    (state: RootStateOrAny) => state?.courses?.courseReview
  );
  const videoLoading = useSelector(
    (state: RootStateOrAny) => state?.courses?.videoLoading
  );
  const getVideoStatus = useSelector(
    (state: RootStateOrAny) => state?.courses?.getVideoStatus
  );
  const videoEnd = useSelector(
    (state: RootStateOrAny) => state?.helperReducer?.videoEnd
  );

  const videoRef = useRef<HTMLVideoElement>(null);

  const clearPreviewState = (): void => {
    setVideoIndex(0);
    dispatch(modifyHelperReducerData({ key: 'videoEnd', value: '' }));
    setVideoPreviewMode(false);
    setVideo('');
  };

  useEffect(() => {
    dispatch(modifyHelperReducerData({ key: 'videoEnd', value: '' }));
    return () => {
      setModalVideoOpen(false);
      setMockTestQuery({
        page: 1,
        per_page: 5,
        course: course?.slug,
      });
      getMockTestList({
        data: {
          page: 1,
          per_page: 5,
          course: course?.slug,
        },
      });
      setVideoIndex(0);
      setModalVideoOpen(false);
    };
  }, []);

  // useEffect(() => {
  //   // dispatch(getMockTestList({ data: { ...mockTestQuery, page: 1 } }));
  //   const header = document.getElementById('myHeader');
  //   // const scrollCallBack = window.addEventListener('scroll', () => {
  //   //   if (typeof window !== undefined) {
  //   //     var totalPageHeight = document.body.scrollHeight;
  //   //     var scrollPoint = window.scrollY + window.innerHeight;
  //   //     if (isMobile || scrollPoint + 320 >= totalPageHeight) {
  //   //       header.classList.remove('sticky');
  //   //     } else {
  //   //       header.classList.add('sticky');
  //   //     }
  //   //   }
  //   // });
  //   return () => {
  //     setMockTestQuery({
  //       page: 1,
  //       per_page: 5,
  //       course: course?.slug,
  //     });
  //     setVideoIndex(0);
  //     setModalVideoOpen(false);
  //   };
  // }, []);

  const toggle = (tab: string): void => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  useEffect(() => {
    dispatch(
      getMockTestList({
        data: {
          ...mockTestQuery,
        },
      })
    );
  }, [mockTestQuery]);

  const getVideo = (
    slug: string,
    name: string,
    preview: boolean,
    toggleSample: boolean
  ) => {
    if (slug && preview) {
      dispatch(getCourseVedio(slug));
      setVideo(name);
      setVideoSlug(slug);
      if (!toggleSample) setModalVideoOpen(true);
    }
    setVideoPreviewMode(true);
    Array.from(document.getElementsByClassName('ant-modal-wrap')).forEach((each) =>
      each.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    );
  };

  // useEffect(() => {
  //   if (getVideoStatus === "success") {
  //     Array.from(document.getElementsByClassName('ant-modal-wrap')).forEach((each) => each.scrollTo({
  //       top: 0,
  //       behavior: 'smooth',
  //     }));
  //   }
  // }, [getVideoStatus])

  const toggleReadMore = (): void => {
    setIsReadMore(!isReadMore);
  };

  const closeVideo = (): void => {
    var vjs = videojs('learnsic-player_html5_api');
    // var myPlayer = videoRef.current;
    setModalVideoOpen(false);
    vjs.pause();
    // myPlayer && myPlayer.pause();
  };

  const addEnroll = (): void => {
    dispatch(
      addCourseEnroll({
        course: course.id,
        content: course?.subject[0]?.chapter[0]?.content[0]?.id,
      })
    );
    window.location.href = `/course/lesson/${course.slug}/`;
  };
  useEffect(() => {
    if (course?.slug) {
      dispatch(getCourseDetail(course.slug));
    }
  }, [course]);
  useEffect(() => {
    const token: string | null = localStorage.getItem('token');
    // dispatch(clearPaymentData())
    if (token) {
      setAuth(true);
    }
    let arr: Array<any> = [];
    course?.subject?.length !== 0 &&
      course?.subject?.map(
        (subj) =>
          subj.chapter?.length !== 0 &&
          subj?.chapter?.map(
            (chap) =>
              chap?.content?.length !== 0 &&
              chap?.content?.map((cont) =>
                cont?.preview === true ? arr.push(cont) : ''
              )
          )
      );
    setPreviewContents(arr);
  }, []);

  useEffect(() => {
    if (videoEnd === 'success') {
      previewContents.find(
        (each, index) =>
          each?.video === videoSlug &&
          (dispatch(modifyHelperReducerData({ key: 'videoEnd', value: '' })),
          index + 1 < previewContents?.length
            ? (dispatch(getCourseVedio(previewContents[index + 1]['video'])),
              setVideo(previewContents[index + 1]['name']),
              setVideoSlug(previewContents[index + 1]['video']))
            : (setVideo(each['name']), setVideoSlug(each['video'])))
      );
    }
  }, [videoEnd]);

  useEffect(() => {
    const perPage: number = 5;
    dispatch(getCourseReview(course.slug, perPage));
  }, []);

  const ModalLoginOpen = (): void => {
    dispatch(
      setData({
        name: 'helperObj',
        key: 'loginModal',
        value: !loginModal,
      })
    );
  };

  const onBuyNowClick = (): void => {
    dispatch(setPaymentEditData({ key: 'orders', value: course }));
  };
  // Course sidebar on scroll logic
  const BOTTOM_SIZE: string =
    courseEnroll?.related_courses?.length !== 0 ? '5px' : '-20px';
  const WIDTH_SIZE: string = '250px';
  try {
    if (typeof window !== 'undefined') {
      const learnsicNavbar: HTMLElement | null = document.getElementById('navbar');
      const courseSidebarElements = document.querySelectorAll<HTMLElement>(
        '.course-details-area'
      );
      let courseSidebar: HTMLElement | null;
      if (courseSidebarElements?.length > 0) {
        courseSidebar = courseSidebarElements[0]?.querySelector(
          '.single-details-sidbar'
        );
      } else {
        courseSidebar = null;
      }
      if (!isMobile) {
        window.onscroll = function (e: Event) {
          if (courseSidebar !== null) {
            if (learnsicNavbar.classList.contains('is-sticky')) {
              const courseDetails: HTMLDivElement = document.querySelector(
                '.course-details-page'
              );
              const footerSection: HTMLDivElement =
                document.querySelector('.footer-section ');
              var subtractWidth = screen.height > 768 ? 120 : 380;
              // : (window.outerWidth > 821 && window.outerWidth < 992 ? 480 : 380);
              if (
                courseDetails !== null &&
                footerSection !== null &&
                window.innerHeight + window.scrollY >=
                  courseDetails.offsetHeight +
                    (footerSection.offsetHeight - subtractWidth)
              ) {
                // If footer reaches
                courseSidebar.classList.add('position-absolute');
                courseSidebar.classList.remove('position-fixed');
                courseSidebar.style.top = 'auto';
                courseSidebar.style.bottom = BOTTOM_SIZE;
                if (isTablet) {
                  courseSidebar.style.width = WIDTH_SIZE;
                }
              } else {
                courseSidebar.classList.remove('position-absolute');
                courseSidebar.classList.add('position-fixed');
                courseSidebar.style.removeProperty('top');
                courseSidebar.style.removeProperty('bottom');
                if (isTablet) {
                  courseSidebar.style.width = WIDTH_SIZE;
                }
              }
              courseSidebar.style.marginTop = '80px';
            } else {
              courseSidebar.style.marginTop = '0px';
            }
          }
        };
      } else {
        courseSidebar.classList.remove('position-fixed');
        courseSidebar.classList.remove('position-absolute');
        courseSidebar.style.top = 'auto';
        courseSidebar.style.bottom = BOTTOM_SIZE;
      }
    }
  } catch (e) {}

  interface IListData {
    id: number;
    image: string;
    href: string;
    title: string;
    course: string;
    duration: string;
    full_marks: number;
    pass_mark: number;
    test_type: string;
    subject: string;
    free: boolean;
  }
  const listData: Array<IListData> = [];
  for (let i = 0; i < mockTestLanding?.data?.data?.length; i++) {
    let data = mockTestLanding?.data?.data[i];
    listData.push({
      href: `/mock-test/${
        data?.test_type == 'LISTENING'
          ? 'listening'
          : data?.test_type == 'WRITING'
          ? 'writing'
          : data?.test_type == 'READING'
          ? 'reading'
          : data?.test_type == 'SPEAKING'
          ? 'speaking'
          : 'normal'
      }/${data.slug}`,
      id: data?.id,
      image: data?.image,
      title: data?.title,
      course: data?.course?.name,
      duration: data?.duration && timeToMinutes(data?.duration) + ' Mins',
      full_marks: data?.total_mark,
      pass_mark: data?.pass_mark,
      test_type: data?.test_type,
      subject: data?.subject?.name,
      free: data?.is_free,
    });
  }

  return (
    <>
      <div ref={modalRef}>
        <Modal
          className="preview-video-modal"
          visible={modalLessonOpen}
          onCancel={() => closeVideo()}
          maskClosable={false}
          footer={null}
          title={
            <>
              <div>
                <small>Course Preview</small>
              </div>
              <span className="d-block">{video}</span>
            </>
          }
          width={700}
          // centered
        >
          {!videoLoading ? (
            <div className="">
              <VideoHLS
                source={courseVideo?.file}
                timeoutAction={false}
                watermark={false}
              />
            </div>
          ) : (
            <div
              className="video-js vjs-theme-forest vjs-big-play-centered"
              style={{ paddingTop: '56.25%', width: '100%' }}
            >
              <div className="videoLoading vjs-big-play-button">
                {/* <Spin indicator={<LoadingOutlined className='loading-spin' spin />} /> */}
              </div>
            </div>
          )}
          <PreviewContents
            getVideo={getVideo}
            previewContents={previewContents}
            video={video}
            course={course}
          />
        </Modal>
      </div>
      <Modal
        visible={loginModal}
        // handleClick={handleAdd}
        onCancel={() => ModalLoginOpen()}
        // buttonLabel1="Add"
        footer={[]}
        maskClosable={false}
        width={450}
        // style={{ marginTop: '-50px' }}
      >
        <div className="banner-form">
          <Login is_instructor={false} isLoginPage={false} isModal />
        </div>
      </Modal>
      <div
        className={`main-wrapper course-details-page ${isMobile ? 'mb-2' : 'mb-5'}`}
      >
        {/* Course Details */}
        <section className={`course-details-area ${isMobile ? 'mb-2' : ''}`}>
          <div className="container">
            <div className="row">
              <div className="col-lg-8 col-md-8 col-sm-12">
                <div className="course-details-top border border-muted border-14 p-3">
                  {!isMobile && (
                    <div className="course-details-banner mb-3 text-center mx-auto">
                      {/* <img
                        src={course?.image}
                        alt=""
                        className="img-responsive w-75"
                        style={{ objectFit: 'cover' }}
                      // width="87%"

                      /> */}
                      <Image
                        // src="/images/saas-image/reducedimage.webp"
                        src={course?.image || '/images/saas-image/reducedimage.webp'}
                        alt="image"
                        // layout='contain'
                        width="800px"
                        height="320px"
                        className="animate__animated animate__fadeInUp animate__delay-0.5s tranform-up-hover box-shadow-hover"
                        priority
                      />
                    </div>
                  )}

                  {isMobile && (
                    <div>
                      <div className="single-details-sidbar">
                        <div
                          className="course-details-feature mb-4 shadow-none"
                          id="myHeader"
                        >
                          <DetailsCard
                            loading={loading}
                            course={course}
                            courseEnroll={courseEnroll}
                            auth={auth}
                            addEnroll={addEnroll}
                            onBuyNowClick={onBuyNowClick}
                            ModalLoginOpen={ModalLoginOpen}
                            videoLoading={videoLoading}
                            getVideo={getVideo}
                            previewContents={previewContents}
                            video={video}
                            videoPreviewMode={videoPreviewMode}
                            courseVideo={courseVideo}
                            clearPreviewState={clearPreviewState}
                            videoRef={videoRef}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="mb-3">
                    <div className="heading">
                      <h1
                        className="text-secondary montserrat-font-family font-weight-bold"
                        style={{ fontSize: '24px !important', fontStyle: 'normal' }}
                      >
                        {course?.name}
                      </h1>
                    </div>
                    <div className="d-flex justify-content-between">
                      <>
                        {course?.coming_soon ? (
                          <>
                            <Badge className="p-1 h-25 mt-2 bg-danger shadow-lg rounded">
                              <span
                                className="font-weight-bold text-white"
                                style={{ fontSize: '13px' }}
                              >
                                Coming Soon
                              </span>
                            </Badge>
                          </>
                        ) : (
                          <span className="course-rating d-flex justify-content-between mt-1">
                            {course?.total_feedback != 0 ? (
                              <>
                                <Rate
                                  disabled
                                  allowHalf
                                  defaultValue={course?.average_rating}
                                  style={{
                                    cursor: 'pointer',
                                    fontSize: '16px',
                                    color: '#FABB02',
                                    marginTop: '2px',
                                  }}
                                />
                                <small
                                  className="ml-2 mt-auto text-muted"
                                  style={{
                                    fontSize: '16px',
                                    // color: '#fbbc05',
                                  }}
                                >
                                  {course?.average_rating?.toFixed(1)}
                                </small>
                                <small
                                  className="ml-2 mt-auto text-muted reviewtip"
                                  style={{
                                    fontSize: '16px',
                                    // color: '#fbbc05',
                                  }}
                                >
                                  ({course?.total_feedback})
                                  <span className="tooltiptext">No. of Review</span>
                                </small>
                              </>
                            ) : null}
                          </span>
                        )}
                      </>
                      {/* <img src='/images/svgs/watch online.svg' width={"30px"} /> */}
                    </div>
                    <div className="d-flex mt-2 montserrat-font-family">
                      {course?.total_enroll >= 100 ? <div className="text-dark" style={{ fontSize: '14px' }}>
                        Enrolled: {course?.total_enroll}
                      </div> : null }
                      {/* { course?.duration != "0:00:00"? <div className="text-dark ml-4" style={{ fontSize: '14px' }}>
                        Duration: {course?.duration} 
                      </div>: null } */}
                    </div>
                  </div>
                  <div className="course-tab-list">
                    <Nav className="flex-column bg-light">
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === '1' })}
                          onClick={() => {
                            toggle('1');
                          }}
                        >
                          Overview
                        </NavLink>
                      </NavItem>
                      <NavItem></NavItem>
                      {course?.instructor || course?.teachers?.length !== 0 ? (
                        <NavItem>
                          <NavLink
                            className={classnames({ active: activeTab === '3' })}
                            onClick={() => {
                              toggle('3');
                            }}
                          >
                            Instructor
                          </NavLink>
                        </NavItem>
                      ) : null}
                      {courseReviews?.data?.length != 0 ? (
                        <NavItem>
                          <NavLink
                            className={classnames({ active: activeTab === '4' })}
                            onClick={() => {
                              toggle('4');
                            }}
                          >
                            Review
                          </NavLink>
                        </NavItem>
                      ) : null}
                      {mockTestLanding?.data?.data?.length > 0 && (
                        <NavItem>
                          <NavLink
                            className={classnames({ active: activeTab === '5' })}
                            onClick={() => {
                              toggle('5');
                            }}
                          >
                            Mock Test
                          </NavLink>
                        </NavItem>
                      )}
                    </Nav>

                    <TabContent activeTab={activeTab}>
                      <TabPane tabId="1" className="overview-tab">
                        <div className="course-learn">
                          {/* {loading ? (
                            <Skeleton active />
                          ) : ( */}
                          <>
                            <h5 className={`heading ml-2 ${isMobile ? 'mt-4' : ''}`}>
                              Learning Outcome
                            </h5>
                            <div
                              className="bg-light p-3 border-14 course-description-contents"
                              dangerouslySetInnerHTML={{ __html: course?.outcome }}
                            ></div>
                          </>
                        </div>
                        {/* Course Content */}
                        {course?.subject?.length > 0 && (
                          <CourseContent
                            clickPreview={clickPreview}
                            course={course}
                            getVideo={getVideo}
                            isMobile={isMobile}
                            cRef={ref}
                          />
                        )}
                        <div className="course-desc text-dark">
                          {/* {loading ? (
                            <Skeleton active />
                          ) : ( */}
                          <>
                            <h5 className="heading ml-2">Course Description</h5>
                            <div
                              className="bg-light p-3 border-14 course-description-contents"
                              // dangerouslySetInnerHTML={{
                              //   __html: course?.description,
                              // }}
                            >
                              <InnerHtmlReadMore
                                size={250}
                                text={course?.description}
                              />
                            </div>{' '}
                          </>
                        </div>
                        <div className="course-feature">
                          {/* {loading ? (
                            <Skeleton active />
                          ) : ( */}
                          <>
                            <h5 className="heading ml-2">Course Requirement</h5>
                            <div
                              className="bg-light p-3 border-14 course-description-contents"
                              dangerouslySetInnerHTML={{
                                __html: course?.requirement,
                              }}
                            ></div>
                          </>
                        </div>
                        {/* <div className="d-flex mt-4 mr-5">
                          <div className='p-2'>Share this course on:</div>
                          {
                            socialMediaImages?.map((each, key) =>
                              <div className=''>
                                <Link href={each?.url}>
                                  <a target="__blank" title={each?.title}>
                                    <SocialMediaIcons src={each?.image} key={each?.id} />
                                  </a>
                                </Link>
                              </div>
                            )
                          }
                        </div> */}
                      </TabPane>
                      {/* {
                        <TabPane tabId="2" className="curriculum-tab">
                          <CourseContent clickPreview={clickPreview} course={course} getVideo={getVideo} isMobile={isMobile} ref={ref} />
                        </TabPane>
                      } */}
                      <TabPane tabId="3" className="instructor-tab">
                        <h5
                          className={`heading font-weight-normal mt-3 ${
                            isMobile ? 'mt-4' : ''
                          }`}
                        >
                          Course Instructors
                        </h5>

                        <div className="">
                          {course?.teachers?.length !== 0 && (
                            <>
                              <TutorListView
                                tutors={course?.teachers}
                                type="teacher"
                              />
                              {/* <div className='d-flex justify-content-end pr-5 pb-3'>
                                <div>3 Courses</div>
                                <div>35 Enrolled</div>
                              </div> */}
                            </>
                          )}
                        </div>
                      </TabPane>
                      <TabPane tabId="4" className="review-tab">
                        <CourseReview
                          courseReview={courseReviews}
                          courseSlug={course?.slug}
                        />
                      </TabPane>
                      {mockTestLanding?.data?.data?.length > 0 && (
                        <TabPane tabId="5" className="mocktest-tab">
                          {/* <MockTestItemGrid
                              mockTestData={mockTestLanding?.data?.data}
                              total={
                                mockTestLanding?.total ? mockTestLanding?.total : 10
                              }
                              loading={mockTestLanding?.loading}
                              isCourseDetailComponent={true}
                              mockTestQuery={mockTestQuery}
                              course={course}
                            /> */}
                          <h5
                            className={`heading ml-2 font-weight-500 ${
                              isMobile ? 'mt-4' : ''
                            }`}
                            style={{ fontWeight: '500 !important' }}
                          >
                            MockTest
                          </h5>
                          {listData?.map((item) => (
                            <MockTestItem item={item} key={item?.id} />
                          ))}
                        </TabPane>
                      )}
                    </TabContent>
                  </div>
                </div>
                {!loading && courseEnroll?.related_courses?.length !== 0 && (
                  <div className="border border-muted border-14 mb-30 mt-5 p-3">
                    <div className="container">
                      <h5 className="mb-4" style={{ fontWeight: '500 !important' }}>
                        Other Popular Courses
                      </h5>
                      <div className="row">
                        {/* {
                        courseEnroll?.related_courses?.map((each) =>
                          <div className='col-lg-6 col-md-6 col-sm-12' key={each?.id}>
                          <CourseSingleItem isDetailPage course={each} />
                          </div>
                        )
                      } */}
                        {/* <CustomCarousel courses={courses} /> */}
                        <CustomCourseCarousel
                          courses={courseEnroll?.related_courses}
                          count={isTablet ? 1 : 2}
                          isDetailPage
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {!isMobile ? (
                <div className="col-lg-4 col-md-4 col-sm-12 start-learning bg-white">
                  <div
                    className="single-details-sidbar"
                    style={{
                      width:
                        typeof window !== 'undefined' &&
                        window.outerWidth >= 819 &&
                        !isLaptop
                          ? '250px'
                          : '320px',
                    }}
                  >
                    <div
                      className="mb-4 shadow-sm rounded-0 border border-top border-14"
                      // style={isTablet && { marginRight: '30px' }}
                      id="myHeader"
                    >
                      <DetailsCard
                        loading={loading}
                        course={course}
                        courseEnroll={courseEnroll}
                        auth={auth}
                        addEnroll={addEnroll}
                        onBuyNowClick={onBuyNowClick}
                        ModalLoginOpen={ModalLoginOpen}
                        videoLoading={videoLoading}
                        getVideo={getVideo}
                        previewContents={previewContents}
                        video={video}
                        videoPreviewMode={videoPreviewMode}
                        courseVideo={courseVideo}
                        clearPreviewState={clearPreviewState}
                        videoRef={videoRef}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}

              {/* <div className="widget">
                <h5 className="text-secondary widget-title">Share On</h5>
                <ul className="list-unstyled social-icon mt-4 mb-0">
                  <li className="list-inline-item mr-2">
                    <a className="rounded">
                      <FacebookShareButton url={courseUrl}>
                        <i className="fab fa-facebook"></i>
                      </FacebookShareButton>
                    </a>
                  </li>
                  <li className="list-inline-item mr-1">
                    <a className="rounded">
                      <TwitterShareButton
                        url={courseUrl}
                        hashtags={[course?.test?.name, 'learnsic']}
                      >
                        <i className="fab fa-twitter"></i>
                      </TwitterShareButton>
                    </a>
                  </li>
                </ul>
              </div> */}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default CourseDetails;
const SocialMediaIcons = ({ src }) =>
  <div className='ml-2 p-2' style={{ color: "blue", borderRadius: '50%' }}>
    <Image className='mt-1' src={src} width={"15.749px"} height="18.425px" />
  </div>

const MockTestItem = ({ item }) => {
  const { isGalaxyZFold }: IBooleanArgs = useWidth();
  return (
    <div className="mb-4 mt-4 col-lg-12 col-sm-12" key={item?.index}>
      <Badge.Ribbon text={item?.free ? "Free" : "Paid"} color="#c71a23">
        <div className={`bg-light border-14 ${isGalaxyZFold ? 'p-1' : 'p-3'}`}>
          <div className="d-flex">
            {
              !isGalaxyZFold &&
              <img width={112} alt="logo" src={"https://d1k0ex3y89plmw.cloudfront.net/media/public/mocktest_uploads/2022_06_03_21_50_59_message.jpg"} />
            }
            <div className="d-flex flex-column m-4">
              <div className="d-flex justify-content-between">
                <h5 className="text-dark mb-2 pb-2 my-auto font-weight-bold">
                  <a href={item.href}>{item.title}</a>
                </h5>
                {/* <span className="bg-danger font-weight-500 text-white border-18 pl-3 pr-3 pt-1 pb-1 ml-3" style={{ fontSize: '12px' }}>Free</span> */}
              </div>
              <div className="row">
                <div className="col">
                  {!item.free && (
                    <div className="mock-course">
                      <span className="text-dark">Course:</span>{' '}
                      <span className="cursor-pointer">
                        <span className="course">{item?.course}</span>
                      </span>
                    </div>
                  )}

                  <div className="mock-duration mt-2">
                    <span className="text-dark">Duration:</span>{' '}
                    <span>
                      <span className="dur">
                        {parseFloat(item?.duration) > 60
                          ? timeConvert(item?.duration)
                          : item?.duration}
                      </span>
                    </span>
                  </div>
                  {/* {item.free && <Badge.Ribbon text="Free" color="#c71a23" />} */}
                  {!item.free && (
                    <div className="mock-subject mt-2">
                      <span className="text-dark">Subject:</span>{' '}
                      <span>
                        <span className="sub">{item?.subject}</span>
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

        </div>
      </Badge.Ribbon>
    </div>
  )
}

const PreviewContents = ({ previewContents, getVideo, video, course }) => {
  return (
    <div className="mt-3 p-3">
      {previewContents?.length !== 0 && (
        <>
          <b>Free Demo Videos:</b>
          <List
            itemLayout="horizontal"
            dataSource={previewContents}
            renderItem={(item, index) => (
              <List.Item
                className={`sample-course-list p-4 border-0 shadow-none my-2 cursor-pointer ${video === item["name"] ? 'selected-sample text-white' : ''
                  }`}
                onClick={() =>
                  video !== item["name"] && getVideo(item["video"], item["name"], item["preview"], true)
                }
              >
                <div className='d-flex justify-content-between'>
                  <img alt="" width="60" height="40" className="course-preview--preview-thumbnail--3NXLX" src={item["video_thumbnail"] ? item["video_thumbnail"] : course?.image} />
                  <b className='my-auto ml-2'>{item["name"]}</b>
                </div>
                <div>{item["length"]}</div>
              </List.Item>
            )}
          />
        </>
      )}
    </div>
  )
}

const DetailsCard = ({
  loading,
  course,
  courseEnroll,
  auth,
  addEnroll,
  onBuyNowClick,
  ModalLoginOpen,
  videoLoading,
  getVideo,
  previewContents,
  video,
  videoPreviewMode,
  courseVideo,
  clearPreviewState,
  videoRef
}) => {
  const dispatch = useDispatch();
  const courseUrl = `${process.env.NEXT_PUBLIC_SITE_URL}course/${course?.slug}`;
  const [adPreview, setAdPreview] = useState(false);
  var discountedPrice =
    courseEnroll?.price - (courseEnroll?.discount_percentage / 100) * courseEnroll?.price;
  const { isMobile } = useWidth();
  const onHeartClick = (slug) => {
    dispatch(addCourseToWishList(slug))
  }
  return (
    // New code
    <>
      <Modal
        visible={adPreview}
        title={<h6 className="font-weight-bold">Course Preview</h6>}
        onCancel={() => {
          setAdPreview(false);
          // var myPlayer = videoRef.current;
          var myPlayer = videojs('learnsic-player_html5_api');
          myPlayer.pause();
        }}
        maskClosable={false}
        footer={false}
        width={850}
        // centered
      >
        {!videoPreviewMode ? (
          <Video
            source={course?.ad_video?.file}
            timeoutAction={false}
            watermark={false}
            videoRef={videoRef}
          />
        ) : !videoLoading ? (
          <>
            <VideoHLS
              source={courseVideo?.file}
              timeoutAction={false}
              watermark={false}
              videoRef={videoRef}
            />
          </>
        ) : (
          <div
            className="video-js vjs-theme-forest vjs-big-play-centered"
            style={{ paddingTop: '56.25%', width: '100%' }}
          >
            <div className="videoLoading vjs-big-play-button">
              {/* <Spin indicator={<LoadingOutlined className='loading-spin' spin />} /> */}
            </div>
          </div>
        )}
        <PreviewContents
          getVideo={getVideo}
          previewContents={previewContents}
          video={video}
          course={course}
        />
      </Modal>
      {course?.ad_video ? (
        <div className="mt-3 mx-0">
          <div
            className={`position-relative ${!isMobile ? 'pl-3 pr-3' : ''} border-14`}
          >
            <img
              alt="course-preview"
              height={300}
              src={
                course?.ad_video?.poster
                  ? course?.ad_video?.poster
                  : course?.image
                  ? course?.image
                  : '/images/course.webp'
              }
              style={{ minHeight: '170px' }}
            />
            <div
              className="course-preview-play bg-white"
              onClick={() => {
                setAdPreview(true);
                clearPreviewState();
              }}
            >
              <i className="fas fa-play-circle" style={{ color: '#c71a23' }}></i>
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
      {
        // course?.price &&
        <>
          {
            <>
              {course?.price &&
                courseEnroll?.discount_percentage > 0 &&
                courseEnroll?.discount_percentage < 100 &&
                !courseEnroll?.is_under_membership &&
                !courseEnroll?.is_enroll && (
                  <div className="text-dark text-center d-flex flex-column justify-content-center pt-2">
                    <span
                      className="text-dark text-uppercase"
                      style={{ fontSize: '18px', fontWeight: '550' }}
                    >
                      {courseEnroll?.currency === 'NPR' ? 'Rs.' : '$'}
                      {discountedPrice.toFixed(2)}/-
                    </span>
                    <del
                      className="ml-1 text-dark font-weight-normal text-uppercase montserrat-font-family"
                      style={{ fontSize: '15px' }}
                    >
                      {courseEnroll?.currency === 'NPR' ? 'Rs.' : '$'}
                      {courseEnroll?.price}/-
                    </del>
                  </div>
                )}
              <div className="text-center pt-2 pl-3 pr-3 pb-3">
                <div>
                  {course?.coming_soon ? (
                    <Button
                      className="btn-danger  border-18 border-danger text-white"
                      style={{ cursor: 'wait' }}
                    >
                      Coming Soon
                    </Button>
                  ) : !course?.is_free &&
                    (course?.is_enroll || courseEnroll.is_enroll) ? (
                    course.live ? (
                      <ul className="list-unstyled feature-list">
                        {/* <li className="text-black">
                                <i className="las la-bookmark"></i> Live class list:{' '}
                                <span className="text-black">
                                  <Link href={`/class-list/?course=${course.slug}`}>
                                    <Button size="small">View</Button>
                                  </Link>
                                </span>
                              </li> */}
                        {course?.is_content_null ? null : courseEnroll?.is_under_membership ? ( // <div className="start-learning-btn">
                          <Link href={`/course/lesson/${course.slug}/`}>
                            <a>
                              <Button className="btn-secondary border-18  border-danger">
                                {courseEnroll?.content_started
                                  ? 'Continue Learning'
                                  : 'Start Learning'}
                              </Button>
                            </a>
                          </Link>
                        ) : (
                          <Button
                            className="btn-secondary border-18  border-danger "
                            onClick={onBuyNowClick}
                          >
                            <Link href={`/course/${course?.slug}/order`}>
                              <a>Renew now</a>
                            </Link>
                          </Button>
                        )}
                      </ul>
                    ) : courseEnroll?.is_under_membership ? (
                      <Link href={`/course/lesson/${course.slug}/`}>
                        <a>
                          <Button className="btn-secondary border-18  border-danger">
                            {courseEnroll?.content_started
                              ? 'Continue Learning'
                              : 'Start Learning'}
                          </Button>
                        </a>
                      </Link>
                    ) : (
                      <Button
                        className="btn-secondary  border-danger border-18 text-hover-danger"
                        onClick={onBuyNowClick}
                      >
                        <Link href={`/course/${course?.slug}/order`}>
                          <a>Renew now</a>
                        </Link>
                      </Button>
                    )
                  ) : auth ? (
                    course?.is_free ? (
                      loading ? (
                        <Skeleton.Button active className="" />
                      ) : courseEnroll?.is_enroll ? (
                        <Link href={`/course/lesson/${course.slug}/`}>
                          <a>
                            <Button className="btn-secondary border-18  border-danger">
                              {courseEnroll?.content_started
                                ? 'Continue Learning'
                                : 'Start Learning'}
                            </Button>
                          </a>
                        </Link>
                      ) : (
                        <div className="d-flex justify-content-center">
                          <Button
                            className="btn-secondary  border-18 border-danger"
                            onClick={() => addEnroll()}
                          >
                            Enroll Now
                          </Button>
                          {courseEnroll?.wishlist ? (
                            <HeartFilled
                              className="text-danger cursor-pointer ml-2 mt-1"
                              style={{ fontSize: '24px' }}
                              title="Remove from wishlist"
                              onClick={() => onHeartClick(course?.slug)}
                            />
                          ) : (
                            <HeartOutlined
                              className={'text-dark mt-1 ml-2 cursor-pointer'}
                              style={{ fontSize: '24px' }}
                              title="Add to wishlist"
                              onClick={() => onHeartClick(course?.slug)}
                            />
                          )}
                        </div>
                      )
                    ) : loading ? (
                      <Skeleton.Button active className="" />
                    ) : (
                      <div className="d-flex justify-content-center">
                        <Link href={`/course/${course?.slug}/order`}>
                          <a>
                            <Button
                              className="btn-secondary  border-18 border-danger  text-hover-danger text-white"
                              onClick={onBuyNowClick}
                              icon={
                                <ShoppingCartOutlined
                                  className="mb-1"
                                  style={{ fontSize: '20px' }}
                                />
                              }
                            >
                              Buy Now
                            </Button>
                          </a>
                        </Link>

                        {/* <Button
                              className={course?.wishlist ? "btn-secondary border-18 ml-2 border-danger text-hover-danger text-white"
                                : "btn-white border-18 ml-2 border-dark text-danger text-hover-danger text-white"
                              }
                              icon={<HeartOutlined
                                className={!course?.wishlist ? 'text-white' : 'text-danger'}
                                style={{ fontSize: '20px', verticalAlign: "-2.15px !important" }} />}
                            /> */}
                        {courseEnroll?.wishlist ? (
                          <HeartFilled
                            className="text-danger cursor-pointer ml-2 mt-1"
                            style={{ fontSize: '24px' }}
                            title="Remove from wishlist"
                            onClick={() => onHeartClick(course?.slug)}
                          />
                        ) : (
                          <HeartOutlined
                            className={'text-dark mt-1 ml-2 cursor-pointer'}
                            style={{ fontSize: '24px' }}
                            title="Add to wishlist"
                            onClick={() =>
                              !isLogin()
                                ? ModalLoginOpen()
                                : onHeartClick(course?.slug)
                            }
                          />
                        )}
                      </div>
                    )
                  ) : loading ? (
                    <Skeleton.Button active className="" />
                  ) : (
                    <>
                      <Button
                        className="btn-secondary   border-18 border-danger"
                        onClick={() => ModalLoginOpen()}
                      >
                        Enroll Now
                      </Button>
                      <HeartOutlined
                        className={'text-dark mt-1 ml-2 cursor-pointer'}
                        style={{ fontSize: '24px' }}
                        title="Add to wishlist"
                        onClick={() => ModalLoginOpen()}
                      />
                    </>
                  )}
                </div>
                <div className="border-bottom-solid mt-2 mb-2" />
                
                  <div className="d-flex flex-column">
                    <strong
                      className="text-dark montserrat-font-family"
                      style={{ fontSize: '10px' }}
                    >
                      Materials included
                    </strong>
                    <span className="text-muted montserrat-font-family">
                      Recorded lessons videos
                    </span>
                    {course?.live && (course?.is_enroll || courseEnroll.is_enroll) ? (
                      <span className="text-dark montserrat-font-family"> 
                        <Link href={`/class-list/?course=${course.slug}`}>
                          <Button className='border-18 border-danger' size="small">Live class</Button>
                        </Link>
                      </span>
                    ): course?.live ? (
                      <span className="text-dark montserrat-font-family">
                          Live class available
                      </span>
                    ): (null)}
                  </div>
                {/* <div className='border-bottom-solid mt-2 mb-2' />
                <div className='d-flex flex-column justify-content-center'>
                  <strong className='text-dark montserrat-font-family mr-2' style={{ fontSize: '10px' }}>Share this course on</strong>
                  <div className='pt-1'>
                    <a className="rounded" title='Facebook' style={{ color: "#3b5998" }}>
                      <FacebookShareButton url={courseUrl}>
                        <i className="fab fa-facebook fa-lg" ></i>
                      </FacebookShareButton>
                    </a>
                    <a className="rounded ml-2" title='Twitter' style={{ color: "#00acee !important" }}>
                      <TwitterShareButton
                        url={courseUrl}
                        hashtags={[course?.test?.name, 'learnsic']}
                      >
                        <i className="fab fa-twitter fa-lg text-secondary" ></i>
                      </TwitterShareButton>
                    </a>
                  </div>
                </div> */}
              </div>

              {/* {auth &&
                !courseEnroll?.is_under_membership &&
                courseEnroll?.is_enroll &&
                (
                  <li className="text-black">
                    <i className="las la-bookmark"></i> Renew Price:{' '}
                    <span className="text-black font-weight-bold ml-2">
                      {
                        course?.currency === "NPR" ?
                          "Rs."
                          :
                          "$"
                      }
                      {(discountedPrice / 2).toFixed(2)}
                    </span>
                  </li>
                )} */}
            </>
          }
        </>
      }
    </>
  );
};

const CourseContent = ({ course, clickPreview, getVideo, cRef, isMobile, }) => {
  const { Panel } = Collapse;
  const [showMore, setShowMore] = useState(false);
  const [expand, setExpand] = useState(false);
  return (
    <div className="course-element mb-5">
      <div className="d-flex justify-content-between">
        <h5 className="heading ml-2 font-weight-normal">Course Content</h5>
        {/* <div className='mt-2 cursor-pointer font-weight-bold text-secondary' style={{ fontSize: '12px' }} onClick={() => {
          setExpand(!expand);
          !expand && setShowMore(true);
        }
        }>
          {expand ? "Collapse" : "Expand"} all sections</div> */}
      </div>
      {course?.subject?.length > 0 ? (
        course?.subject?.slice(0, showMore ? course?.subject?.length : 1)?.map((data, keySubject) => (
          <div className="course-item" key={keySubject}>
            <div className="course-content show mb-0">
              <div className="course-button text-muted text-capitalize montserrat-font-family">{data.name}</div>
              {data?.chapter?.map(
                (dataChapter, keyChapter) => {
                  const arrayOfKeys = data?.chapter?.map((panel, index) => index);
                  return (
                    <div
                      className="content mt-1"
                      key={keyChapter}
                    >
                      <Collapse
                        accordion
                        // activeKey={(!expand && !showMore) ? (keySubject === 0 ? ['0'] : []) : expand ? arrayOfKeys : []} 
                        defaultActiveKey={(!expand && !showMore) ? (keySubject === 0 ? ['0'] : []) : expand ? arrayOfKeys : []}>
                        {/* keySubject === 0 ? ['0'] : expand ? arrayOfKeys : [] */}
                        <Panel
                          header={
                            <>
                              <strong>
                                {' '}
                                {dataChapter.name}{' '}
                              </strong>
                              <span className="lectures float-right ml-auto">
                                {' '}
                                ({dataChapter.no_contents}{' '}
                                lectures -{' '}
                                {dataChapter.chapter_length})
                              </span>
                            </>
                          }
                          key={keyChapter}
                        >
                          <ul className="list-unstyled">
                            {dataChapter.content.map(
                              (dataContent, key) => (
                                <li
                                  key={key}
                                  style={{
                                    display: 'flow-root',
                                  }}
                                >
                                  <span className="play-icon">
                                    {dataContent?.preview ? (
                                      <i className="fas fa-file-video"></i>
                                    ) : (
                                      <i className="fas fa-play-circle"></i>
                                    )}
                                  </span>

                                  <span
                                    className={`content-title ml-2 ${dataContent?.preview
                                      ? 'clickable'
                                      : ''
                                      }`}
                                    onClick={() =>
                                      clickPreview?.videoSlug !==
                                      dataContent?.video &&
                                      getVideo(
                                        dataContent.video,
                                        dataContent.name,
                                        dataContent.preview,
                                        false
                                      )
                                    }
                                  >
                                    {dataContent.name}
                                  </span>
                                  <span className="content-duration">
                                    <span
                                      ref={cRef}
                                      className={`content-title ml-2 ${isMobile
                                        ? 'float-right'
                                        : ''
                                        }`}
                                      onClick={() =>
                                        getVideo(
                                          dataContent.video,
                                          dataContent.name,
                                          dataContent.preview,
                                          false
                                        )
                                      }
                                    >
                                      {dataContent?.preview ? (
                                        <span className="mr-2 clickable">
                                          Preview
                                        </span>
                                      ) : (
                                        <i className="fas fa-lock mr-2"></i>
                                      )}
                                    </span>
                                    {isMobile ? (
                                      <>
                                        <br />
                                        <span className="float-right">
                                          {dataContent?.length}
                                        </span>
                                      </>
                                    ) : (
                                      dataContent?.length || (
                                        <span
                                          style={{
                                            visibility: 'hidden',
                                          }}
                                        >
                                          {dataContent?.length}
                                        </span>
                                      )
                                    )}
                                  </span>
                                </li>
                              )
                            )}
                          </ul>
                        </Panel>
                      </Collapse>
                    </div>
                  )
                }
              )}

            </div>
          </div>
        ))
      ) : (
        <Empty className="ptb-100" />
      )}
      {
        !showMore &&
        <Button onClick={() => setShowMore(true)} className='d-block btn-secondary border-danger border-18 text-white mx-auto'>Show More Contents</Button>
      }
    </div>
  )
}
